import { Link } from "react-router-dom";
import { t } from "ttag";

import type { Appointment } from "@/features/consultations/models";
import { useBoolean } from "@/shared/hooks";
import { Button, Popover, VideoCameraIcon } from "@/shared/ui";
import { tw } from "@/shared/utils";

interface JoinNowButtonProps {
  canJoin: boolean;
  videoUrl: Appointment["videoUrl"];
}

export const JoinNowButton = ({ canJoin, videoUrl }: JoinNowButtonProps) => {
  const {
    value: showTooltip,
    setFalse: closeTooltip,
    setTrue: openTooltip,
    setValue: toggleTooltip,
  } = useBoolean(false);

  const TriggerComponent = canJoin ? Button : Popover.Trigger;
  const Component = canJoin ? Link : Button;
  const handleMouseEnter = canJoin ? undefined : openTooltip;
  const handleMouseLeave = canJoin ? undefined : closeTooltip;

  return (
    <Popover.Root open={showTooltip} onOpenChange={toggleTooltip}>
      <TriggerComponent
        asChild
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={tw(
          "grow px-4",
          !canJoin && "cursor-help bg-neutral-400 hover:bg-neutral-500/70",
        )}
        size="lg"
      >
        <Component to={videoUrl ?? ""} target="_blank" rel="noreferrer">
          <VideoCameraIcon className="size-5" />
          {t`Join now`}
        </Component>
      </TriggerComponent>

      <Popover.Content>
        {t`Available 10 minutes before your session.`}
      </Popover.Content>
    </Popover.Root>
  );
};
